import {getProperty, hasProperty, setProperty} from 'dot-prop'
import {DateTime} from 'luxon'

import {getTranslations} from './translations'

export function isObject(item) {
	return typeof item === 'object' && !Array.isArray(item) && item !== null
}

export function clearFormModelFields(schema, formModel) {
	for (const field of schema.fields) {
		if (!field.show_if || field.show_if.length === 0) {
			continue
		}

		// for each field.show_if field, check if that field is truthy
		if (field.path.includes('[0]')) {
			// it's a container -> multiple
			let i = 0
			while (hasProperty(formModel, field.path.replace('[0]', `[${i}]`))) {
				const curr = i
				i++
				const fieldPath = field.path.replace('[0]', `[${curr}]`)
				const fieldValue = getProperty(formModel, fieldPath)

				// if the value is already falsy so no need to further check it
				if (!fieldValue) {
					continue
				}

				// make sure it meets the show_if requirements, otherwise nullify it
				for (const showifField of field.show_if) {
					const showifPath = schema.fields
						.find(x => x.key === showifField)
						.path.replace('[0]', `[${curr}]`)
					const showifValue = getProperty(formModel, showifPath)

					if (!showifValue) {
						setProperty(formModel, fieldPath, null)
					}
				}
			}
		} else {
			// it's something else (container not multiple or normal field)
			// if in the the future you want to clear non-children fields with show_if, code it here,
			// this wasn't done at first because you want want to clear up rooms if user changes arrival_departure dates
			// so maybe show_if should become clear_if_not?
		}
	}
}

export function parseEventTitle(title) {
	let parsedTitle = title

	if (parsedTitle.includes(' - ')) {
		const titleParts = parsedTitle.split(' - ')
		const lastPart = titleParts.pop()

		if (
			// prettier-ignore
			[
			'gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre',
			'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december',
			'januar', 'februar', 'marsch', 'april', 'kann', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'dezember',
		].some(month => lastPart.toLowerCase().includes(month))
		) {
			parsedTitle = titleParts.join(' - ')
		}
	}

	return parsedTitle
}

export function parseEventDate({start, end}, language) {
	const t$ = getTranslations(language.id)

	const sameDay =
		DateTime.fromMillis(start).toFormat('yyyy-MM-dd') ===
		DateTime.fromMillis(end).toFormat('yyyy-MM-dd')

	const sameMonth =
		DateTime.fromMillis(start).toFormat('yyyy-MM') === DateTime.fromMillis(end).toFormat('yyyy-MM')

	const sameYear =
		DateTime.fromMillis(start).toFormat('yyyy') === DateTime.fromMillis(end).toFormat('yyyy')

	// sameDay -> "Sabato 5 feb 2022 10:00"
	// sameMonth -> "Da sabato 5 a domenica 6 feb 2022"
	// sameYear -> "Da sabato 5 feb a martedì 8 mar 2022"
	// else -> "Da sabato 5 feb 2022 a martedì 8 dic 2023"
	if (sameDay) {
		return capitalizeFirstLetter(
			DateTime.fromMillis(start).toFormat('EEEE d MMMM yyyy HH:mm', {locale: language.code})
		)
	} else if (sameMonth) {
		return capitalizeFirstLetter(
			[
				t$.date_from,
				DateTime.fromMillis(start).toFormat('EEEE d', {locale: language.code}),
				t$.date_to,
				DateTime.fromMillis(end).toFormat('EEEE d MMM yyyy', {locale: language.code}),
			].join(' ')
		)
	} else if (sameYear) {
		return capitalizeFirstLetter(
			[
				t$.date_from,
				DateTime.fromMillis(start).toFormat('EEEE d MMM', {locale: language.code}),
				t$.date_to,
				DateTime.fromMillis(end).toFormat('EEEE d MMM yyyy', {locale: language.code}),
			].join(' ')
		)
	} else {
		return capitalizeFirstLetter(
			[
				t$.date_from,
				DateTime.fromMillis(start).toFormat('EEEE d MMM yyyy', {locale: language.code}),
				t$.date_to,
				DateTime.fromMillis(end).toFormat('EEEE d MMM yyyy', {locale: language.code}),
			].join(' ')
		)
	}
}

export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}
